// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = '@import url("//at.alicdn.com/t/c/font_1522685_g8y5lppbqmv.css");\n.freelog {\n  line-height: 1;\n  font-size: 18px;\n  display: inline-block;\n}\n';
      document.head.appendChild(s);
    }
  }
})();

// src/FIcons/FAdd/index.tsx
import * as React from "react";
function FAdd({ className, ...props }) {
  return /* @__PURE__ */ React.createElement("i", { className: ["freelog", "fl-icon-xinzeng", className].join(" "), ...props });
}
var FAdd_default = FAdd;

// src/FIcons/FArrowDown/index.tsx
import * as React2 from "react";
function FArrowDown({ className, ...props }) {
  return /* @__PURE__ */ React2.createElement("i", { className: ["freelog", "fl-icon-fangxiang", className].join(" "), ...props });
}
var FArrowDown_default = FArrowDown;

// src/FIcons/FArrowRight/index.tsx
import * as React3 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FArrowRight/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FArrowRight/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__TdP3M {\n  transform: rotate(-90deg);\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FArrowRight_default = { "icon": "index__icon__TdP3M" };

// src/FIcons/FArrowRight/index.tsx
function FArrowRight({ className, ...props }) {
  return /* @__PURE__ */ React3.createElement("i", { className: ["freelog", "fl-icon-fangxiang", FArrowRight_default.icon, className].join(" "), ...props });
}
var FArrowRight_default2 = FArrowRight;

// src/FIcons/FBinding/index.tsx
import * as React4 from "react";
function FBinding({ className, ...props }) {
  return /* @__PURE__ */ React4.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-bangding", className].join(" "),
      ...props
    }
  );
}
var FBinding_default = FBinding;

// src/FIcons/FCancelCollect/index.tsx
import * as React5 from "react";
function FCancelCollect({ className, ...props }) {
  return /* @__PURE__ */ React5.createElement("i", { className: ["freelog", "fl-icon-yishoucang", className].join(" "), ...props });
}
var FCancelCollect_default = FCancelCollect;

// src/FIcons/FCheck/index.tsx
import * as React6 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FCheck/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FCheck/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__oVydW {\n  color: #44C28C;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FCheck_default = { "icon": "index__icon__oVydW" };

// src/FIcons/FCheck/index.tsx
function FCheck({ className, ...props }) {
  return /* @__PURE__ */ React6.createElement("i", { className: ["freelog", "fl-icon-shenqingchenggong1", FCheck_default.icon, className].join(" "), ...props });
}
var FCheck_default2 = FCheck;

// src/FIcons/FCheckMark/index.tsx
import * as React7 from "react";
function FCheckMark({ className, ...props }) {
  return /* @__PURE__ */ React7.createElement("i", { className: ["freelog", "fl-icon-xuanzhong", className].join(" "), ...props });
}
var FCheckMark_default = FCheckMark;

// src/FIcons/FCircleDelete/index.tsx
import * as React8 from "react";
function FCircleDelete({ className, ...props }) {
  return /* @__PURE__ */ React8.createElement("i", { className: ["freelog", "fl-icon-bianji_yuanxing", className].join(" "), ...props });
}
var FCircleDelete_default = FCircleDelete;

// src/FIcons/FCircleEdit/index.tsx
import * as React9 from "react";
function FCircleEdit({ className, ...props }) {
  return /* @__PURE__ */ React9.createElement("i", { className: ["freelog", "fl-icon-shanchu_yuanxing", className].join(" "), ...props });
}
var FCircleEdit_default = FCircleEdit;

// src/FIcons/FClose/index.tsx
import * as React10 from "react";
function FClose({ className, ...props }) {
  return /* @__PURE__ */ React10.createElement("i", { className: ["freelog", "fl-icon-guanbi", className].join(" "), ...props });
}
var FClose_default = FClose;

// src/FIcons/FCloudUpload/index.tsx
import * as React11 from "react";
function FCloudUpload({ className, ...props }) {
  return /* @__PURE__ */ React11.createElement("i", { className: ["freelog", "fl-icon-shangchuanfengmian", className].join(" "), ...props });
}
var FCloudUpload_default = FCloudUpload;

// src/FIcons/FCode/index.tsx
import * as React12 from "react";
function FCode({ className, ...props }) {
  return /* @__PURE__ */ React12.createElement("i", { className: ["freelog", "fl-icon-daima", className].join(" "), ...props });
}
var FCode_default = FCode;

// src/FIcons/FCollect/index.tsx
import * as React13 from "react";
function FCollect({ className, ...props }) {
  return /* @__PURE__ */ React13.createElement("i", { className: ["freelog", "fl-icon-shoucang", className].join(" "), ...props });
}
var FCollect_default = FCollect;

// src/FIcons/FComposition/index.tsx
import * as React14 from "react";
function FComposition({ className, ...props }) {
  return /* @__PURE__ */ React14.createElement("i", { className: ["freelog", "fl-icon-zuhemoshi", className].join(" "), ...props });
}
var FComposition_default = FComposition;

// src/FIcons/FConfiguration/index.tsx
import * as React15 from "react";
function FConfiguration({ className, ...props }) {
  return /* @__PURE__ */ React15.createElement("i", { className: ["freelog", "fl-icon-kexuanpeizhi", className].join(" "), ...props });
}
var FConfiguration_default = FConfiguration;

// src/FIcons/FContent/index.tsx
import * as React16 from "react";
function FContent({ className, ...props }) {
  return /* @__PURE__ */ React16.createElement("i", { className: ["freelog", "fl-icon-moban", className].join(" "), ...props });
}
var FContent_default = FContent;

// src/FIcons/FContract/index.tsx
import * as React17 from "react";
function FContract({ className, ...props }) {
  return /* @__PURE__ */ React17.createElement("i", { className: ["freelog", "fl-icon-heyue1", className].join(" "), ...props });
}
var FContract_default = FContract;

// src/FIcons/FCopy/index.tsx
import * as React18 from "react";
function FCopy({ className, ...props }) {
  return /* @__PURE__ */ React18.createElement("i", { className: ["freelog", "fl-icon-fuzhimingcheng", className].join(" "), ...props });
}
var FCopy_default = FCopy;

// src/FIcons/FCreate/index.tsx
import * as React19 from "react";
function FCreate({ className, ...props }) {
  return /* @__PURE__ */ React19.createElement("i", { className: ["freelog", "fl-icon-chuangjian_shixin", className].join(" "), ...props });
}
var FCreate_default = FCreate;

// src/FIcons/FDecrease/index.tsx
import * as React20 from "react";
function FDecrease({ className = "", ...props }) {
  return /* @__PURE__ */ React20.createElement("i", { className: ["freelog", "fl-icon-shouqi2", className].join(" "), ...props });
}
var FDecrease_default = FDecrease;

// src/FIcons/FDelete/index.tsx
import * as React21 from "react";
function FDelete({ className = "", ...props }) {
  return /* @__PURE__ */ React21.createElement("i", { className: ["freelog", "fl-icon-shanchu", className].join(" "), ...props });
}
var FDelete_default = FDelete;

// src/FIcons/FDoubleDown/index.tsx
import * as React22 from "react";
function FDoubleUp({ className = "", ...props }) {
  return /* @__PURE__ */ React22.createElement("i", { className: ["freelog", "fl-icon-shouqi1", className].join(" "), ...props });
}
var FDoubleDown_default = FDoubleUp;

// src/FIcons/FDoubleUp/index.tsx
import * as React23 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FDoubleUp/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FDoubleUp/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__3mee2 {\n  transform: rotate(180deg);\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FDoubleUp_default = { "icon": "index__icon__3mee2" };

// src/FIcons/FDoubleUp/index.tsx
function FDoubleUp2({ className = "", ...props }) {
  return /* @__PURE__ */ React23.createElement("i", { className: ["freelog", "fl-icon-shouqi1", FDoubleUp_default.icon, className].join(" "), ...props });
}
var FDoubleUp_default2 = FDoubleUp2;

// src/FIcons/FDown/index.tsx
import * as React24 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FDown/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FDown/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__qiTVh {\n  transform: rotate(90deg);\n  display: inline-block;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FDown_default = { "icon": "index__icon__qiTVh" };

// src/FIcons/FDown/index.tsx
function FDown({ className, ...props }) {
  return /* @__PURE__ */ React24.createElement("i", { className: ["freelog", "fl-icon-zhankaigengduo", FDown_default.icon, className].join(" "), ...props });
}
var FDown_default2 = FDown;

// src/FIcons/FDownload/index.tsx
import * as React25 from "react";
function FDownload({ className, ...props }) {
  return /* @__PURE__ */ React25.createElement("i", { className: ["freelog", "fl-icon-xiazai1", className].join(" "), ...props });
}
var FDownload_default = FDownload;

// src/FIcons/FEdit/index.tsx
import * as React26 from "react";
function FEdit({ className, ...props }) {
  return /* @__PURE__ */ React26.createElement("i", { className: ["freelog", "fl-icon-bianji", className].join(" "), ...props });
}
var FEdit_default = FEdit;

// src/FIcons/FExclamation/index.tsx
import * as React27 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FExclamation/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FExclamation/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__Pr0aS {\n  color: #44C28C;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FExclamation_default = { "icon": "index__icon__Pr0aS" };

// src/FIcons/FExclamation/index.tsx
function FExclamation({ className, ...props }) {
  return /* @__PURE__ */ React27.createElement("i", { className: ["freelog", "fl-icon-warningxiaochicun", FExclamation_default.icon, className].join(" "), ...props });
}
var FExclamation_default2 = FExclamation;

// src/FIcons/FExit/index.tsx
import * as React28 from "react";
function FExit({ className, ...props }) {
  return /* @__PURE__ */ React28.createElement("i", { className: ["freelog", "fl-icon-tuichu", className].join(" "), ...props });
}
var FExit_default = FExit;

// src/FIcons/FExport/index.tsx
import * as React29 from "react";
function FExport({ className, ...props }) {
  return /* @__PURE__ */ React29.createElement("i", { className: ["freelog", "fl-icon-daochu", className].join(" "), ...props });
}
var FExport_default = FExport;

// src/FIcons/FFail/index.tsx
import * as React30 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FFail/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FFail/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__warning__KnxHW {\n  color: #FFC704;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FFail_default = { "warning": "index__warning__KnxHW" };

// src/FIcons/FFail/index.tsx
function FFail({ className, ...props }) {
  return /* @__PURE__ */ React30.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-shibai", FFail_default.warning, className].join(" "),
      ...props
    }
  );
}
var FFail_default2 = FFail;

// src/FIcons/FFavorite/index.tsx
import * as React31 from "react";
function FFavorite({ filled = false, className, ...props }) {
  if (!filled) {
    return /* @__PURE__ */ React31.createElement(
      "i",
      {
        className: ["freelog", "fl-icon-shoucang", className].join(" "),
        ...props
      }
    );
  }
  return /* @__PURE__ */ React31.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-yishoucang", className].join(" "),
      ...props
    }
  );
}
var FFavorite_default = FFavorite;

// src/FIcons/FFeather/index.tsx
import * as React32 from "react";
function FFeather({ className, ...props }) {
  return /* @__PURE__ */ React32.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-feather", className].join(" "),
      ...props
    }
  );
}
var FFeather_default = FFeather;

// src/FIcons/FFileSearch/index.tsx
import * as React33 from "react";
function FFileSearch({ className, ...props }) {
  return /* @__PURE__ */ React33.createElement("i", { className: ["freelog", "fl-icon-chakanziyuan", className].join(" "), ...props });
}
var FFileSearch_default = FFileSearch;

// src/FIcons/FFileText/index.tsx
import * as React34 from "react";
function FFileText({ className, ...props }) {
  return /* @__PURE__ */ React34.createElement("i", { className: ["freelog", "fl-icon-moban", className].join(" "), ...props });
}
var FFileText_default = FFileText;

// src/FIcons/FForbid/index.tsx
import * as React35 from "react";
function FForbid({ className, ...props }) {
  return /* @__PURE__ */ React35.createElement("i", { className: ["freelog", "fl-icon-jinzhi", className].join(" "), ...props });
}
var FForbid_default = FForbid;

// src/FIcons/FFreelog/index.tsx
import * as React36 from "react";
function FFreelog({ className, ...props }) {
  return /* @__PURE__ */ React36.createElement("i", { className: ["freelog", "fl-icon-a-featherlogo5", className].join(" "), ...props });
}
var FFreelog_default = FFreelog;

// src/FIcons/FFullScreen/index.tsx
import * as React37 from "react";
function FFullScreen({ className, ...props }) {
  return /* @__PURE__ */ React37.createElement("i", { className: ["freelog", "fl-icon-quanping", className].join(" "), ...props });
}
var FFullScreen_default = FFullScreen;

// src/FIcons/FGuideDown/index.tsx
import * as React38 from "react";
function FGuideDown({ className, ...props }) {
  return /* @__PURE__ */ React38.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-xiangxia", className].join(" "),
      ...props
    }
  );
}
var FGuideDown_default = FGuideDown;

// src/FIcons/FImport/index.tsx
import * as React39 from "react";
function FImport({ className, ...props }) {
  return /* @__PURE__ */ React39.createElement("i", { className: ["freelog", "fl-icon-daoru", className].join(" "), ...props });
}
var FImport_default = FImport;

// src/FIcons/FIncrease/index.tsx
import * as React40 from "react";
function FIncrease({ className, ...props }) {
  return /* @__PURE__ */ React40.createElement("i", { className: ["freelog", "fl-icon-zhankai1", className].join(" "), ...props });
}
var FIncrease_default = FIncrease;

// src/FIcons/FInfo/index.tsx
import * as React41 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FInfo/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FInfo/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = "";
      document.head.appendChild(s);
    }
  }
})();
var FInfo_default = {};

// src/FIcons/FInfo/index.tsx
function FInfo({ className, style, ...props }) {
  return /* @__PURE__ */ React41.createElement(
    "i",
    {
      className: [FInfo_default.styles, "freelog", "fl-icon-tishixinxi", className].join(" "),
      style,
      ...props
    }
  );
}
var FInfo_default2 = FInfo;

// src/FIcons/FLeft/index.tsx
import * as React42 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FLeft/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FLeft/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__lBjQ3 {\n  transform: rotate(180deg);\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FLeft_default = { "icon": "index__icon__lBjQ3" };

// src/FIcons/FLeft/index.tsx
function FLeft({ className, ...props }) {
  return /* @__PURE__ */ React42.createElement("i", { className: ["freelog", "fl-icon-zhankaigengduo", FLeft_default.icon, className].join(" "), ...props });
}
var FLeft_default2 = FLeft;

// src/FIcons/FLine/index.tsx
import * as React43 from "react";
function FLine({ className, ...props }) {
  return /* @__PURE__ */ React43.createElement("i", { className: ["freelog", "fl-icon-zhanweifu", className].join(" "), ...props });
}
var FLine_default = FLine;

// src/FIcons/FLinkedin/index.tsx
import * as React44 from "react";
function FLinkedin({ className, ...props }) {
  return /* @__PURE__ */ React44.createElement("i", { className: ["freelog", "fl-icon-linkedin", className].join(" "), ...props });
}
var FLinkedin_default = FLinkedin;

// src/FIcons/FLoading/index.tsx
import * as React45 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FLoading/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FLoading/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__t9MyS {\n  color: #2784FF;\n  animation: index__loadingCircle__Z75I- 1s infinite;\n}\n@keyframes index__loadingCircle__Z75I- {\n  to {\n    transform: rotate(360deg);\n  }\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FLoading_default = { "icon": "index__icon__t9MyS", "loadingCircle": "index__loadingCircle__Z75I-" };

// src/FIcons/FLoading/index.tsx
function FLoading({ className, ...props }) {
  return /* @__PURE__ */ React45.createElement("i", { className: ["freelog", "fl-icon-loading", FLoading_default.icon, className].join(" "), ...props });
}
var FLoading_default2 = FLoading;

// src/FIcons/FLocalUpload/index.tsx
import * as React46 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FLocalUpload/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FLocalUpload/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = "";
      document.head.appendChild(s);
    }
  }
})();
var FLocalUpload_default = {};

// src/FIcons/FLocalUpload/index.tsx
function FLocalUpload({ className, style, ...props }) {
  return /* @__PURE__ */ React46.createElement(
    "i",
    {
      className: [FLocalUpload_default.styles, "freelog", "fl-icon-bendishangchuan", className].join(" "),
      style,
      ...props
    }
  );
}
var FLocalUpload_default2 = FLocalUpload;

// src/FIcons/FLock/index.tsx
import * as React47 from "react";
function FLock({ className, ...props }) {
  return /* @__PURE__ */ React47.createElement("i", { className: ["freelog", "fl-icon-suoding", className].join(" "), ...props });
}
var FLock_default = FLock;

// src/FIcons/FLoudspeaker/index.tsx
import * as React48 from "react";
function FLoudspeaker({ className, ...props }) {
  return /* @__PURE__ */ React48.createElement("i", { className: ["freelog", "fl-icon-tongzhi", className].join(" "), ...props });
}
var FLoudspeaker_default = FLoudspeaker;

// src/FIcons/FMappingRuleActive/index.tsx
import * as React49 from "react";
function FMappingRuleActive({ className, ...props }) {
  return /* @__PURE__ */ React49.createElement("i", { className: ["freelog", "fl-icon-jihuozhuti", className].join(" "), ...props });
}
var FMappingRuleActive_default = FMappingRuleActive;

// src/FIcons/FMappingRuleAdd/index.tsx
import * as React50 from "react";
function FMappingRuleAdd({ className, ...props }) {
  return /* @__PURE__ */ React50.createElement("i", { className: ["freelog", "fl-icon-xinzengdezhanpin", className].join(" "), ...props });
}
var FMappingRuleAdd_default = FMappingRuleAdd;

// src/FIcons/FMappingRuleAttr/index.tsx
import * as React51 from "react";
function FMappingRuleAttr({ className, ...props }) {
  return /* @__PURE__ */ React51.createElement("i", { className: ["freelog", "fl-icon-zidingyishuxing", className].join(" "), ...props });
}
var FMappingRuleAttr_default = FMappingRuleAttr;

// src/FIcons/FMappingRuleCover/index.tsx
import * as React52 from "react";
function FMappingRuleCover({ className, ...props }) {
  return /* @__PURE__ */ React52.createElement("i", { className: ["freelog", "fl-icon-fengmian", className].join(" "), ...props });
}
var FMappingRuleCover_default = FMappingRuleCover;

// src/FIcons/FMappingRuleLabel/index.tsx
import * as React53 from "react";
function FMappingRuleLabel({ className, ...props }) {
  return /* @__PURE__ */ React53.createElement("i", { className: ["freelog", "fl-icon-biaoqian", className].join(" "), ...props });
}
var FMappingRuleLabel_default = FMappingRuleLabel;

// src/FIcons/FMappingRuleOffline/index.tsx
import * as React54 from "react";
function FMappingRuleOffline({ className, ...props }) {
  return /* @__PURE__ */ React54.createElement("i", { className: ["freelog", "fl-icon-xiaxian", className].join(" "), ...props });
}
var FMappingRuleOffline_default = FMappingRuleOffline;

// src/FIcons/FMappingRuleOnline/index.tsx
import * as React55 from "react";
function FMappingRuleOnline({ className, ...props }) {
  return /* @__PURE__ */ React55.createElement("i", { className: ["freelog", "fl-icon-shangxian", className].join(" "), ...props });
}
var FMappingRuleOnline_default = FMappingRuleOnline;

// src/FIcons/FMappingRuleReplace/index.tsx
import * as React56 from "react";
function FMappingRuleReplace({ className, ...props }) {
  return /* @__PURE__ */ React56.createElement("i", { className: ["freelog", "fl-icon-tihuan", className].join(" "), ...props });
}
var FMappingRuleReplace_default = FMappingRuleReplace;

// src/FIcons/FMappingRuleTitle/index.tsx
import * as React57 from "react";
function FMappingRuleTitle({ className, ...props }) {
  return /* @__PURE__ */ React57.createElement("i", { className: ["freelog", "fl-icon-biaoti", className].join(" "), ...props });
}
var FMappingRuleTitle_default = FMappingRuleTitle;

// src/FIcons/FMappingRuleVersion/index.tsx
import * as React58 from "react";
function FMappingRuleVersion({ className, ...props }) {
  return /* @__PURE__ */ React58.createElement("i", { className: ["freelog", "fl-icon-banben", className].join(" "), ...props });
}
var FMappingRuleVersion_default = FMappingRuleVersion;

// src/FIcons/FNavigate/index.tsx
import * as React59 from "react";
function FNavigate({ className, ...props }) {
  return /* @__PURE__ */ React59.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-fangwen", className].join(" "),
      ...props
    }
  );
}
var FNavigate_default = FNavigate;

// src/FIcons/FNodes/index.tsx
import * as React60 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FNodes/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FNodes/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__style__QDUfc {\n  color: #F5A623;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FNodes_default = { "style": "index__style__QDUfc" };

// src/FIcons/FNodes/index.tsx
function FNodes({ className, ...props }) {
  return /* @__PURE__ */ React60.createElement("i", { className: ["freelog", "fl-icon-jiedian", className, FNodes_default.style].join(" "), ...props });
}
var FNodes_default2 = FNodes;

// src/FIcons/FObject/index.tsx
import * as React61 from "react";
function FObject({ className, ...props }) {
  return /* @__PURE__ */ React61.createElement("i", { className: ["freelog", "fl-icon-duixiang", className].join(" "), ...props });
}
var FObject_default = FObject;

// src/FIcons/FPaperPlane/index.tsx
import * as React62 from "react";
function FPaperPlane({ className, ...props }) {
  return /* @__PURE__ */ React62.createElement("i", { className: ["freelog", "fl-icon-fahang", className].join(" "), ...props });
}
var FPaperPlane_default = FPaperPlane;

// src/FIcons/FPentacle/index.tsx
import * as React63 from "react";
function FPentacle({ className, ...props }) {
  return /* @__PURE__ */ React63.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-shoucangxiaoshuoyishoucang", className].join(" "),
      ...props
    }
  );
}
var FPentacle_default = FPentacle;

// src/FIcons/FPentagram/index.tsx
import * as React64 from "react";
function FPentagram({ className, ...props }) {
  return /* @__PURE__ */ React64.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-xing", className].join(" "),
      ...props
    }
  );
}
var FPentagram_default = FPentagram;

// src/FIcons/FPlayer/index.tsx
import * as React65 from "react";
function FPlayer({ className, ...props }) {
  return /* @__PURE__ */ React65.createElement("i", { className: ["freelog", "fl-icon-bofang", className].join(" "), ...props });
}
var FPlayer_default = FPlayer;

// src/FIcons/FPlus/index.tsx
import * as React66 from "react";
function FPlus({ className, ...props }) {
  return /* @__PURE__ */ React66.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-tianjia", className].join(" "),
      ...props
    }
  );
}
var FPlus_default = FPlus;

// src/FIcons/FPolicy/index.tsx
import * as React67 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FPolicy/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FPolicy/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = "";
      document.head.appendChild(s);
    }
  }
})();
var FPolicy_default = {};

// src/FIcons/FPolicy/index.tsx
function FPolicy({ className, style, ...props }) {
  return /* @__PURE__ */ React67.createElement(
    "i",
    {
      className: [FPolicy_default.styles, "freelog", "fl-icon-celve", className].join(" "),
      style,
      ...props
    }
  );
}
var FPolicy_default2 = FPolicy;

// src/FIcons/FProperty/index.tsx
import * as React68 from "react";
function FProperty({ className, ...props }) {
  return /* @__PURE__ */ React68.createElement("i", { className: ["freelog", "fl-icon-shuxing", className].join(" "), ...props });
}
var FProperty_default = FProperty;

// src/FIcons/FRedo/index.tsx
import * as React69 from "react";
function FRedo({ className, ...props }) {
  return /* @__PURE__ */ React69.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-zhongzhi", className].join(" "),
      ...props
    }
  );
}
var FRedo_default = FRedo;

// src/FIcons/FResource/index.tsx
import * as React70 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FResource/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FResource/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__style__jaSg2 {\n  color: #7ED321;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FResource_default = { "style": "index__style__jaSg2" };

// src/FIcons/FResource/index.tsx
function FResource({ className, ...props }) {
  return /* @__PURE__ */ React70.createElement("i", { className: ["freelog", "fl-icon-ziyuan", className, FResource_default.style].join(" "), ...props });
}
var FResource_default2 = FResource;

// src/FIcons/FResourceFile/index.tsx
import * as React71 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FResourceFile/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FResourceFile/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__style__lZ3E- {\n  color: #7ED321;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FResourceFile_default = { "style": "index__style__lZ3E-" };

// src/FIcons/FResourceFile/index.tsx
function FResourceFile({ className, ...props }) {
  return /* @__PURE__ */ React71.createElement("i", { className: ["freelog", "fl-icon-ziyuanwenjian", className, FResourceFile_default.style].join(" "), ...props });
}
var FResourceFile_default2 = FResourceFile;

// src/FIcons/FRight/index.tsx
import * as React72 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FRight/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FRight/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__wsNUC {\n  transform: rotate(0deg);\n  display: inline-block;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FRight_default = { "icon": "index__icon__wsNUC" };

// src/FIcons/FRight/index.tsx
function FRight({ className, ...props }) {
  return /* @__PURE__ */ React72.createElement("i", { className: ["freelog", "fl-icon-zhankaigengduo", FRight_default.icon, className].join(" "), ...props });
}
var FRight_default2 = FRight;

// src/FIcons/FRotate/index.tsx
import * as React73 from "react";
function FRotate({ className, ...props }) {
  return /* @__PURE__ */ React73.createElement("i", { className: ["freelog", "fl-icon-zhongzhi", className].join(" "), ...props });
}
var FRotate_default = FRotate;

// src/FIcons/FSafetyLock/index.tsx
import * as React74 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FSafetyLock/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FSafetyLock/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__warning__L4W8J {\n  color: #FFC704;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FSafetyLock_default = { "warning": "index__warning__L4W8J" };

// src/FIcons/FSafetyLock/index.tsx
function FSafetyLock({ className, ...props }) {
  return /* @__PURE__ */ React74.createElement("i", { className: ["freelog", "fl-icon-zhongzhimima", FSafetyLock_default.warning, className].join(" "), ...props });
}
var FSafetyLock_default2 = FSafetyLock;

// src/FIcons/FSetting/index.tsx
import * as React75 from "react";
function FSetting({ className, ...props }) {
  return /* @__PURE__ */ React75.createElement("i", { className: ["freelog", "fl-icon-chilun_kongxin", className].join(" "), ...props });
}
var FSetting_default = FSetting;

// src/FIcons/FShare/index.tsx
import * as React76 from "react";
function FShare({ className, ...props }) {
  return /* @__PURE__ */ React76.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-fenxiang", className].join(" "),
      ...props
    }
  );
}
var FShare_default = FShare;

// src/FIcons/FSina/index.tsx
import * as React77 from "react";
function FSina({ className, ...props }) {
  return /* @__PURE__ */ React77.createElement("i", { className: ["freelog", "fl-icon-weibo", className].join(" "), ...props });
}
var FSina_default = FSina;

// src/FIcons/FStorageSpace/index.tsx
import * as React78 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FStorageSpace/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FStorageSpace/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = "";
      document.head.appendChild(s);
    }
  }
})();
var FStorageSpace_default = {};

// src/FIcons/FStorageSpace/index.tsx
function FStorageSpace({ className, style, ...props }) {
  return /* @__PURE__ */ React78.createElement(
    "i",
    {
      className: [FStorageSpace_default.styles, "freelog", "fl-icon-congcunchukongjianxuanze", className].join(" "),
      style,
      ...props
    }
  );
}
var FStorageSpace_default2 = FStorageSpace;

// src/FIcons/FSwap/index.tsx
import * as React79 from "react";
function FSwap({ className, ...props }) {
  return /* @__PURE__ */ React79.createElement("i", { className: ["freelog", "fl-icon-qiehuan", className].join(" "), ...props });
}
var FSwap_default = FSwap;

// src/FIcons/FThickArrowRight/index.tsx
import * as React80 from "react";
function FThickArrowRight({ className, ...props }) {
  return /* @__PURE__ */ React80.createElement("i", { className: ["freelog", "fl-icon-jiantou", className].join(" "), ...props });
}
var FThickArrowRight_default = FThickArrowRight;

// src/FIcons/FUnbinding/index.tsx
import * as React81 from "react";
function FUnbinding({ className, ...props }) {
  return /* @__PURE__ */ React81.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-jiechubangding", className].join(" "),
      ...props
    }
  );
}
var FUnbinding_default = FUnbinding;

// src/FIcons/FUp/index.tsx
import * as React82 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FUp/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FUp/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__icon__-me45 {\n  transform: rotate(-90deg);\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FUp_default = { "icon": "index__icon__-me45" };

// src/FIcons/FUp/index.tsx
function FUp({ className, ...props }) {
  return /* @__PURE__ */ React82.createElement("i", { className: ["freelog", "fl-icon-zhankaigengduo", FUp_default.icon, className].join(" "), ...props });
}
var FUp_default2 = FUp;

// src/FIcons/FUpcast/index.tsx
import * as React83 from "react";
function FUpcast({ className, ...props }) {
  return /* @__PURE__ */ React83.createElement("i", { className: ["freelog", "fl-icon-shangpao", className].join(" "), ...props });
}
var FUpcast_default = FUpcast;

// src/FIcons/FUpdate/index.tsx
import * as React84 from "react";
function FUpdate({ className, ...props }) {
  return /* @__PURE__ */ React84.createElement("i", { className: ["freelog", "fl-icon-gengxin", className].join(" "), ...props });
}
var FUpdate_default = FUpdate;

// src/FIcons/FUpdateVersion/index.tsx
import * as React85 from "react";
function FUpdateVersion({ className, ...props }) {
  return /* @__PURE__ */ React85.createElement("i", { className: ["freelog", "fl-icon-gengxinbanben", className].join(" "), ...props });
}
var FUpdateVersion_default = FUpdateVersion;

// src/FIcons/FUser/index.tsx
import * as React86 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FUser/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FUser/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__style__25RS2 {\n  color: #BD10E0;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FUser_default = { "style": "index__style__25RS2" };

// src/FIcons/FUser/index.tsx
function FUser({ className, ...props }) {
  return /* @__PURE__ */ React86.createElement("i", { className: ["freelog", "fl-icon-yonghu", className, FUser_default.style].join(" "), ...props });
}
var FUser_default2 = FUser;

// src/FIcons/FWarning/index.tsx
import * as React87 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FWarning/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FIcons/FWarning/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__warning__RmrSK {\n  color: #FFC704;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FWarning_default = { "warning": "index__warning__RmrSK" };

// src/FIcons/FWarning/index.tsx
function FWarning({ className, ...props }) {
  return /* @__PURE__ */ React87.createElement(
    "i",
    {
      className: ["freelog", "fl-icon-warning1", FWarning_default.warning, className].join(" "),
      ...props
    }
  );
}
var FWarning_default2 = FWarning;

// src/FIcons/FWeChat/index.tsx
import * as React88 from "react";
function FWeChat({ className, ...props }) {
  return /* @__PURE__ */ React88.createElement("i", { className: ["freelog", "fl-icon-weixin", className].join(" "), ...props });
}
var FWeChat_default = FWeChat;

// src/FIcons/index.tsx
var FIcons = {
  FAdd: FAdd_default,
  FArrowDown: FArrowDown_default,
  FArrowRight: FArrowRight_default2,
  FBinding: FBinding_default,
  FCancelCollect: FCancelCollect_default,
  FCheck: FCheck_default2,
  FCheckMark: FCheckMark_default,
  FCircleDelete: FCircleDelete_default,
  FCircleEdit: FCircleEdit_default,
  FClose: FClose_default,
  FCloudUpload: FCloudUpload_default,
  FCode: FCode_default,
  FCollect: FCollect_default,
  FComposition: FComposition_default,
  FConfiguration: FConfiguration_default,
  FContent: FContent_default,
  FContract: FContract_default,
  FCopy: FCopy_default,
  FCreate: FCreate_default,
  FDecrease: FDecrease_default,
  FDelete: FDelete_default,
  FDoubleDown: FDoubleDown_default,
  FDoubleUp: FDoubleUp_default2,
  FDown: FDown_default2,
  FDownload: FDownload_default,
  FEdit: FEdit_default,
  FExclamation: FExclamation_default2,
  FExit: FExit_default,
  FExport: FExport_default,
  FFail: FFail_default2,
  FFavorite: FFavorite_default,
  FFeather: FFeather_default,
  FFileSearch: FFileSearch_default,
  FFileText: FFileText_default,
  FForbid: FForbid_default,
  FFreelog: FFreelog_default,
  FFullScreen: FFullScreen_default,
  FGuideDown: FGuideDown_default,
  FImport: FImport_default,
  FIncrease: FIncrease_default,
  FInfo: FInfo_default2,
  FLeft: FLeft_default2,
  FLine: FLine_default,
  FLinkedin: FLinkedin_default,
  FLoading: FLoading_default2,
  FLocalUpload: FLocalUpload_default2,
  FLock: FLock_default,
  FLoudspeaker: FLoudspeaker_default,
  FMappingRuleActive: FMappingRuleActive_default,
  FMappingRuleAdd: FMappingRuleAdd_default,
  FMappingRuleAttr: FMappingRuleAttr_default,
  FMappingRuleCover: FMappingRuleCover_default,
  FMappingRuleLabel: FMappingRuleLabel_default,
  FMappingRuleOffline: FMappingRuleOffline_default,
  FMappingRuleOnline: FMappingRuleOnline_default,
  FMappingRuleReplace: FMappingRuleReplace_default,
  FMappingRuleTitle: FMappingRuleTitle_default,
  FMappingRuleVersion: FMappingRuleVersion_default,
  FNavigate: FNavigate_default,
  FNodes: FNodes_default2,
  FObject: FObject_default,
  FPaperPlane: FPaperPlane_default,
  FPentacle: FPentacle_default,
  FPentagram: FPentagram_default,
  FPlayer: FPlayer_default,
  FPlus: FPlus_default,
  FPolicy: FPolicy_default2,
  FProperty: FProperty_default,
  FRedo: FRedo_default,
  FResource: FResource_default2,
  FResourceFile: FResourceFile_default2,
  FRight: FRight_default2,
  FRotate: FRotate_default,
  FSafetyLock: FSafetyLock_default2,
  FSetting: FSetting_default,
  FShare: FShare_default,
  FSina: FSina_default,
  FStorageSpace: FStorageSpace_default2,
  FSwap: FSwap_default,
  FThickArrowRight: FThickArrowRight_default,
  FUnbinding: FUnbinding_default,
  FUp: FUp_default2,
  FUpcast: FUpcast_default,
  FUpdate: FUpdate_default,
  FUpdateVersion: FUpdateVersion_default,
  FUser: FUser_default2,
  FWarning: FWarning_default2,
  FWeChat: FWeChat_default
};
var FIcons_default = FIcons;

// src/F_Contract_And_Policy_Labels/index.tsx
import * as React89 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/F_Contract_And_Policy_Labels/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/F_Contract_And_Policy_Labels/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__styles__igfOH {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n.index__styles__igfOH.index__singleRow__tjJRY {\n  overflow: hidden;\n  flex-wrap: nowrap;\n}\n.index__styles__igfOH .index__label__fxBj7 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(39, 132, 255, 0.1);\n  border-radius: 4px;\n  border: none;\n  padding: 3px 8px;\n  flex-shrink: 0;\n  width: fit-content;\n  box-sizing: border-box;\n}\n.index__styles__igfOH .index__label__fxBj7 .index__labelText__Vkboc {\n  font-size: 12px;\n  font-weight: 600;\n  color: #2784FF;\n  line-height: 18px;\n  display: inline-block;\n}\n.index__styles__igfOH .index__label__fxBj7 .index__labelDot__a3YKm {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  display: inline-block;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var F_Contract_And_Policy_Labels_default = { "styles": "index__styles__igfOH", "singleRow": "index__singleRow__tjJRY", "label": "index__label__fxBj7", "labelText": "index__labelText__Vkboc", "labelDot": "index__labelDot__a3YKm" };

// src/F_Contract_And_Policy_Labels/index.tsx
var colors = {
  green: "#42C28C",
  yellow: "#E9A923"
};
function F_Contract_And_Policy_Labels({ data, singleRow }) {
  return /* @__PURE__ */ React89.createElement("div", { className: [F_Contract_And_Policy_Labels_default.styles, singleRow ? F_Contract_And_Policy_Labels_default.singleRow : ""].join(" ") }, data.map((d, i) => {
    return /* @__PURE__ */ React89.createElement("label", { className: F_Contract_And_Policy_Labels_default.label, key: i }, /* @__PURE__ */ React89.createElement("span", { className: F_Contract_And_Policy_Labels_default.labelText }, d.text), d.dot && /* @__PURE__ */ React89.createElement(React89.Fragment, null, /* @__PURE__ */ React89.createElement("div", { style: { width: 5 } }), /* @__PURE__ */ React89.createElement("i", { className: F_Contract_And_Policy_Labels_default.labelDot, style: { backgroundColor: colors[d.dot] } })));
  }));
}
var F_Contract_And_Policy_Labels_default2 = F_Contract_And_Policy_Labels;

// src/FPageFooter/index.tsx
import * as React90 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FPageFooter/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FPageFooter/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__footer__t0ogg {\n  padding: 0 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 106px;\n  position: relative;\n}\n.index__footer__t0ogg .index__footerLeft__Ed0Eo {\n  display: flex;\n}\n.index__footer__t0ogg .index__footerLeft__Ed0Eo .index__footerLeft_Link__4h3Kj {\n  font-size: 14px;\n  font-weight: 400;\n  color: #666;\n  line-height: 20px;\n  transition: color 0.2s;\n}\n.index__footer__t0ogg .index__footerLeft__Ed0Eo .index__footerLeft_Link__4h3Kj:hover {\n  color: #2784FF;\n}\n.index__footer__t0ogg .index__footerLeft__Ed0Eo .index__Divider__9lf2G {\n  width: 1px;\n  height: 14px;\n  background: rgba(0, 0, 0, 0.08);\n}\n.index__footer__t0ogg .index__footerRight__m2-02 {\n  display: flex;\n  align-items: center;\n}\n.index__footer__t0ogg .index__footerRight__m2-02 .index__policeImg__ZjDex {\n  width: 16px;\n  height: 18px;\n  cursor: pointer;\n}\n.index__footer__t0ogg .index__footerRight__m2-02 .index__footerRightText__RtPM- {\n  font-size: 12px;\n  font-weight: 400;\n  color: #666;\n  line-height: 18px;\n  cursor: pointer;\n}\n.index__PopoverContent__6rqC3 .index__PopoverContentTitle__yWwzF {\n  font-size: 14px;\n  font-weight: 600;\n  color: #222;\n  line-height: 20px;\n  text-align: center;\n}\n.index__PopoverContent__6rqC3 > img {\n  display: block;\n  width: 160px;\n  height: 160px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FPageFooter_default = { "footer": "index__footer__t0ogg", "footerLeft": "index__footerLeft__Ed0Eo", "footerLeft_Link": "index__footerLeft_Link__4h3Kj", "Divider": "index__Divider__9lf2G", "footerRight": "index__footerRight__m2-02", "policeImg": "index__policeImg__ZjDex", "footerRightText": "index__footerRightText__RtPM-", "PopoverContent": "index__PopoverContent__6rqC3", "PopoverContentTitle": "index__PopoverContentTitle__yWwzF" };

// src/FPageFooter/index.tsx
import { Space } from "antd";
import { FUtil, FI18n } from "@freelog/tools-lib";
import { Popover } from "antd";
function FPageFooter({ PopoverPatch, style = {} }) {
  const FPopover = PopoverPatch || Popover;
  return /* @__PURE__ */ React90.createElement("footer", { className: FPageFooter_default.footer, style }, /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.footerLeft }, /* @__PURE__ */ React90.createElement(Space, { size: 20 }, /* @__PURE__ */ React90.createElement(
    "a",
    {
      className: FPageFooter_default.footerLeft_Link,
      href: FUtil.Format.completeUrlByDomain("www"),
      target: "_blank"
    },
    /* @__PURE__ */ React90.createElement(FIcons_default.FFreelog, null)
  ), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.Divider }), /* @__PURE__ */ React90.createElement(
    "a",
    {
      href: FI18n.i18nNext.t("nav_ProductDevActivities_link"),
      target: "_blank",
      className: FPageFooter_default.footerLeft_Link
    },
    FI18n.i18nNext.t("nav_ProductDevActivities")
  ), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.Divider }), /* @__PURE__ */ React90.createElement(
    "a",
    {
      className: FPageFooter_default.footerLeft_Link,
      href: FI18n.i18nNext.t("nav_TermsPrivacy_link"),
      target: "_blank"
    },
    FI18n.i18nNext.t("nav_TermsPrivacy")
  ), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.Divider }), /* @__PURE__ */ React90.createElement(
    "a",
    {
      className: FPageFooter_default.footerLeft_Link,
      href: FI18n.i18nNext.t("nav_AboutUs_link"),
      target: "_blank"
    },
    FI18n.i18nNext.t("nav_AboutUs")
  ), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.Divider }), /* @__PURE__ */ React90.createElement(
    "a",
    {
      className: FPageFooter_default.footerLeft_Link,
      href: FI18n.i18nNext.t("nav_ContactUs_link"),
      target: "_blank"
    },
    FI18n.i18nNext.t("nav_ContactUs")
  ), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.Divider }), /* @__PURE__ */ React90.createElement(
    "a",
    {
      className: FPageFooter_default.footerLeft_Link,
      onClick: () => {
        const currentLanguage = FI18n.i18nNext.getCurrentLanguage();
        FI18n.i18nNext.changeLanguage(currentLanguage !== "zh_CN" ? "zh_CN" : "en_US");
        window.location.reload();
      }
    },
    FI18n.i18nNext.getCurrentLanguage() !== "zh_CN" ? "\u7B80\u4F53\u4E2D\u6587" : "English"
  )), /* @__PURE__ */ React90.createElement("div", { style: { width: 20 } }), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.Divider }), /* @__PURE__ */ React90.createElement("div", { style: { width: 30 } }), /* @__PURE__ */ React90.createElement(Space, { size: 25 }, /* @__PURE__ */ React90.createElement(
    FPopover,
    {
      overlayInnerStyle: {
        width: 200,
        padding: "8px 4px"
      },
      content: /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.PopoverContent }, /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.PopoverContentTitle }, "Freelog\u98DE\u81F4"), /* @__PURE__ */ React90.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React90.createElement("img", { src: FUtil.Domain.STATIC_ORIGIN + "/static/WeChatQR.jpg", alt: "" })),
      title: null
    },
    /* @__PURE__ */ React90.createElement("a", { className: FPageFooter_default.footerLeft_Link }, /* @__PURE__ */ React90.createElement(FIcons_default.FWeChat, null))
  ), /* @__PURE__ */ React90.createElement(
    "a",
    {
      href: FI18n.i18nNext.t("nav_weibologo_link"),
      target: "_blank",
      className: FPageFooter_default.footerLeft_Link
    },
    /* @__PURE__ */ React90.createElement(FIcons_default.FSina, null)
  ))), /* @__PURE__ */ React90.createElement("div", { style: { height: 20 } }), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.footerRight }, /* @__PURE__ */ React90.createElement(
    "a",
    {
      className: FPageFooter_default.footerRightText,
      href: FI18n.i18nNext.t("nav_copyright_link"),
      target: "_blank"
    },
    window.location.origin.includes(".freelog.cn") ? "\u7CA4ICP\u590717085716\u53F7-3" : "\u7CA4ICP\u590717085716\u53F7-2"
  ), /* @__PURE__ */ React90.createElement("div", { style: { width: 20 } }), /* @__PURE__ */ React90.createElement("div", { className: FPageFooter_default.footerRightText }, `Copyright\xA9 2026 ${FUtil.Domain.isProdEnv() ? "freelog.cn" : "testfreelog.com"}`)));
}
var FPageFooter_default2 = FPageFooter;

// src/FDropdown/index.tsx
import * as React91 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FDropdown/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FDropdown/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__dropdown__G8TaF {\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);\n  background-color: white;\n  border-radius: 4px;\n}\n.index__children__w-e-R {\n  display: inline-block;\n  height: fit-content;\n  width: fit-content;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FDropdown_default = { "dropdown": "index__dropdown__G8TaF", "children": "index__children__w-e-R" };

// src/FDropdown/index.tsx
import { Dropdown } from "antd";
function FDropdown(props) {
  const { children, overlay, overlayClassName, overlayStyle, ...rest } = props;
  const dropdownProps = { ...rest };
  delete dropdownProps.overlay;
  delete dropdownProps.overlayClassName;
  delete dropdownProps.overlayStyle;
  return /* @__PURE__ */ React91.createElement(
    Dropdown,
    {
      ...dropdownProps,
      ...overlay ? { popupRender: () => /* @__PURE__ */ React91.createElement("div", { className: [FDropdown_default.dropdown, overlayClassName].filter(Boolean).join(" "), style: overlayStyle }, typeof overlay === "function" ? overlay() : overlay) } : {}
    },
    /* @__PURE__ */ React91.createElement("div", { className: FDropdown_default.children }, children)
  );
}
var FDropdown_default2 = FDropdown;

// src/FButton/FRectBtn/index.tsx
import * as React92 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FButton/FRectBtn/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FButton/FRectBtn/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__styles__Tvwzx {\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  justify-content: center;\n  height: 38px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n}\n.index__primary__Gg-hX {\n  border: none;\n  color: white;\n  background-color: #2784FF;\n}\n.index__primary__Gg-hX:hover {\n  background-color: #529DFF;\n}\n.index__primary__Gg-hX:active {\n  background-color: #2376E5;\n}\n.index__primary__Gg-hX[disabled],\n.index__primary__Gg-hX[disabled]:hover,\n.index__primary__Gg-hX[disabled]:active,\n.index__primary__Gg-hX[disabled]:focus {\n  opacity: 0.4;\n  color: #FFFFFF;\n  background-color: #2784FF;\n  cursor: not-allowed;\n}\n.index__transparent__O9GjD {\n  border: none;\n  color: #666;\n  background-color: transparent;\n}\n.index__transparent__O9GjD:hover {\n  background-color: #EDEDED;\n}\n.index__transparent__O9GjD:active {\n  background-color: #E6E6E6;\n}\n.index__transparent__O9GjD[disabled],\n.index__transparent__O9GjD[disabled]:hover,\n.index__transparent__O9GjD[disabled]:active,\n.index__transparent__O9GjD[disabled]:focus {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.index__default__NpN6M {\n  border: 1px solid #D4D4D4;\n  font-weight: 400;\n  color: #222;\n  background-image: linear-gradient(180deg, #FFFFFF 0%, #F3F4F6 100%);\n}\n.index__default__NpN6M:hover {\n  background-image: linear-gradient(180deg, #529DFF 0%, #529DFF 100%);\n  color: white;\n}\n.index__default__NpN6M:active {\n  background-image: linear-gradient(180deg, #2376E5 0%, #2376E5 100%);\n  color: white;\n}\n.index__default__NpN6M[disabled],\n.index__default__NpN6M[disabled]:hover,\n.index__default__NpN6M[disabled]:active,\n.index__default__NpN6M[disabled]:focus {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.index__secondary__DoCGy {\n  border: none;\n  color: #2784FF;\n  background-color: #EEF6FF;\n}\n.index__secondary__DoCGy:hover {\n  background-color: #F1F8FF;\n  color: #529DFF;\n}\n.index__secondary__DoCGy:active {\n  background-color: #E4F0FF;\n  color: #187AFC;\n}\n.index__secondary__DoCGy[disabled],\n.index__secondary__DoCGy[disabled]:hover,\n.index__secondary__DoCGy[disabled]:active,\n.index__secondary__DoCGy[disabled]:focus {\n  opacity: 0.4;\n  color: #2784FF;\n  background-color: #EEF6FF;\n  cursor: not-allowed;\n}\n.index__danger1__QbU-y {\n  border: none;\n  color: white;\n  background-color: #EE4040;\n}\n.index__danger1__QbU-y:hover {\n  background-color: #F86363;\n}\n.index__danger1__QbU-y:active {\n  background-color: #EB3737;\n}\n.index__danger1__QbU-y[disabled],\n.index__danger1__QbU-y[disabled]:hover,\n.index__danger1__QbU-y[disabled]:active,\n.index__danger1__QbU-y[disabled]:focus {\n  opacity: 0.4;\n  background-color: #EE4040;\n  cursor: not-allowed;\n}\n.index__danger2__kostH {\n  border: none;\n  color: #EE4040;\n  background-color: #FDEBEB;\n}\n.index__danger2__kostH:hover {\n  background-color: #FEF2F2;\n  color: #F86363;\n}\n.index__danger2__kostH:active {\n  background-color: #FEE6E6;\n  color: #EB3737;\n}\n.index__danger2__kostH[disabled],\n.index__danger2__kostH[disabled]:hover,\n.index__danger2__kostH[disabled]:active,\n.index__danger2__kostH[disabled]:focus {\n  opacity: 0.4;\n  color: #EE4040;\n  background-color: #FDEBEB;\n  cursor: not-allowed;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FRectBtn_default = { "styles": "index__styles__Tvwzx", "primary": "index__primary__Gg-hX", "transparent": "index__transparent__O9GjD", "default": "index__default__NpN6M", "secondary": "index__secondary__DoCGy", "danger1": "index__danger1__QbU-y", "danger2": "index__danger2__kostH" };

// src/FButton/FRectBtn/index.tsx
function FRectBtn({ children, size = "middle", className, style = {}, type = "primary", disabled, onClick }) {
  return /* @__PURE__ */ React92.createElement(
    "button",
    {
      className: [FRectBtn_default.styles, FRectBtn_default[type], className].join(" "),
      style: {
        height: size === "middle" ? 38 : size === "large" ? 50 : 32,
        ...style
      },
      disabled,
      onClick: (event) => {
        onClick && onClick(event);
      }
    },
    children
  );
}
var FRectBtn_default2 = FRectBtn;

// src/FButton/FCircleBtn/index.tsx
import * as React93 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FButton/FCircleBtn/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FButton/FCircleBtn/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__Primary__zU3PH {\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-weight: 600;\n  color: #FFFFFF;\n  font-size: 14px;\n  background-color: #2784FF;\n  cursor: pointer;\n  outline: none;\n  line-height: 1;\n}\n.index__Primary__zU3PH:hover {\n  background-color: #529DFF;\n}\n.index__Primary__zU3PH:active {\n  background-color: #2376E5;\n}\n.index__Primary__zU3PH[disabled],\n.index__Primary__zU3PH[disabled]:hover,\n.index__Primary__zU3PH[disabled]:active,\n.index__Primary__zU3PH[disabled]:focus {\n  opacity: 0.4;\n  background-color: #2784FF;\n  cursor: not-allowed;\n}\n.index__Transparent__-R0hF {\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 26px;\n  width: 26px;\n  font-weight: 600;\n  color: #666;\n  font-size: 14px;\n  background-color: transparent;\n  cursor: pointer;\n  outline: none;\n  border-radius: 50%;\n}\n.index__Transparent__-R0hF:hover {\n  background-color: #529DFF;\n  color: white;\n}\n.index__Transparent__-R0hF:active {\n  background-color: #2376E5;\n  color: white;\n}\n.index__Transparent__-R0hF[disabled],\n.index__Transparent__-R0hF[disabled]:hover,\n.index__Transparent__-R0hF[disabled]:active,\n.index__Transparent__-R0hF[disabled]:focus {\n  opacity: 0.4;\n  background-color: transparent;\n  cursor: not-allowed;\n}\n.index__Danger__VylwX {\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 14px;\n  color: #EE4040;\n  background-color: #FDEBEB;\n  cursor: pointer;\n  outline: none;\n}\n.index__Danger__VylwX:hover {\n  background-color: #F86363;\n  color: white;\n}\n.index__Danger__VylwX:active {\n  background-color: #EB3737;\n  color: white;\n}\n.index__Danger__VylwX[disabled],\n.index__Danger__VylwX[disabled]:hover,\n.index__Danger__VylwX[disabled]:active,\n.index__Danger__VylwX[disabled]:focus {\n  opacity: 0.4;\n  color: #EE4040;\n  background-color: #FDEBEB;\n  cursor: not-allowed;\n}\n.index__Minor__7SsI1 {\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 14px;\n  color: #2784FF;\n  background-color: #E4F0FF;\n  cursor: pointer;\n  outline: none;\n}\n.index__Minor__7SsI1:hover {\n  background-color: #F1F8FF;\n  color: #529DFF;\n}\n.index__Minor__7SsI1:active {\n  background-color: #E4F0FF;\n  color: #529DFF;\n}\n.index__Minor__7SsI1[disabled],\n.index__Minor__7SsI1[disabled]:hover,\n.index__Minor__7SsI1[disabled]:active,\n.index__Minor__7SsI1[disabled]:focus {\n  opacity: 0.4;\n  color: #2784FF;\n  background-color: #E4F0FF;\n  cursor: not-allowed;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FCircleBtn_default = { "Primary": "index__Primary__zU3PH", "Transparent": "index__Transparent__-R0hF", "Danger": "index__Danger__VylwX", "Minor": "index__Minor__7SsI1" };

// src/FButton/FCircleBtn/index.tsx
function FCircleBtn({ children, size = "middle", className, style, disabled, onClick, type = "primary" }) {
  if (type === "primary") {
    return /* @__PURE__ */ React93.createElement(
      "button",
      {
        className: [FCircleBtn_default.Primary, className].join(" "),
        style: {
          height: size === "middle" ? 32 : 22,
          width: size === "middle" ? 32 : 22,
          ...style
        },
        disabled,
        onClick: (event) => {
          onClick && onClick(event);
        }
      },
      children || /* @__PURE__ */ React93.createElement(
        FIcons_default.FPlus,
        {
          style: {
            fontSize: size === "middle" ? 16 : 12
          }
        }
      )
    );
  }
  if (type === "transparent") {
    return /* @__PURE__ */ React93.createElement(
      "button",
      {
        className: [FCircleBtn_default.Transparent, className].join(" "),
        style: {
          ...style
        },
        disabled,
        onClick: (event) => {
          onClick && onClick(event);
        }
      },
      children || /* @__PURE__ */ React93.createElement(FIcons_default.FPlus, { style: {
        fontSize: 14
      } })
    );
  }
  if (type === "minor") {
    return /* @__PURE__ */ React93.createElement(
      "button",
      {
        className: [FCircleBtn_default.Minor, className].join(" "),
        style: {
          ...style
        },
        disabled,
        onClick: (event) => {
          onClick && onClick(event);
        }
      },
      children || /* @__PURE__ */ React93.createElement(FIcons_default.FEdit, { style: {
        fontSize: 14
      } })
    );
  }
  return /* @__PURE__ */ React93.createElement(
    "button",
    {
      className: [FCircleBtn_default.Danger, className].join(" "),
      disabled,
      onClick: (event) => {
        onClick && onClick(event);
      }
    },
    children || /* @__PURE__ */ React93.createElement(FIcons_default.FLine, { style: { fontSize: 12 } })
  );
}
var FCircleBtn_default2 = FCircleBtn;

// src/FButton/FTextBtn/index.tsx
import * as React94 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FButton/FTextBtn/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FButton/FTextBtn/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__textBtn__dvASf {\n  border: none;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  justify-content: center;\n  background-color: transparent;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n}\n.index__textBtn__dvASf[disabled] {\n  cursor: not-allowed;\n}\n.index__primary__JmxTV {\n  color: #2784FF;\n}\n.index__primary__JmxTV:hover {\n  color: #529DFF;\n}\n.index__primary__JmxTV:active {\n  color: #2376E5;\n}\n.index__primary__JmxTV[disabled],\n.index__primary__JmxTV[disabled]:hover,\n.index__primary__JmxTV[disabled]:active,\n.index__primary__JmxTV[disabled]:focus {\n  opacity: 0.4;\n  color: #2784FF;\n}\n.index__default__t0tHg {\n  color: #666;\n}\n.index__default__t0tHg:hover {\n  color: #529DFF;\n}\n.index__default__t0tHg:active {\n  color: #2376E5;\n}\n.index__default__t0tHg[disabled],\n.index__default__t0tHg[disabled]:hover,\n.index__default__t0tHg[disabled]:active,\n.index__default__t0tHg[disabled]:focus {\n  opacity: 0.4;\n  color: #666;\n}\n.index__danger__6y4dv {\n  color: #EE4040;\n}\n.index__danger__6y4dv:hover {\n  color: #F86363;\n}\n.index__danger__6y4dv:active {\n  color: #EB3737;\n}\n.index__danger__6y4dv[disabled],\n.index__danger__6y4dv[disabled]:hover,\n.index__danger__6y4dv[disabled]:active,\n.index__danger__6y4dv[disabled]:focus {\n  opacity: 0.4;\n  color: #EE4040;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FTextBtn_default = { "textBtn": "index__textBtn__dvASf", "primary": "index__primary__JmxTV", "default": "index__default__t0tHg", "danger": "index__danger__6y4dv" };

// src/FButton/FTextBtn/index.tsx
function FTextBtn({ children, type = "primary", className, style, disabled, onClick }) {
  return /* @__PURE__ */ React94.createElement(
    "button",
    {
      className: [FTextBtn_default.textBtn, FTextBtn_default[type], className].join(" "),
      style: {
        ...style
      },
      disabled,
      onClick: (event) => {
        onClick && onClick(event);
      }
    },
    children
  );
}
var FTextBtn_default2 = FTextBtn;

// src/FButton/FButton/index.tsx
import * as React95 from "react";
var rectTypeMap = {
  primary: "primary",
  default: "transparent",
  secondary: "default"
};
function FButton({
  children,
  type = "primary",
  size = "middle",
  icon,
  className,
  style,
  disabled,
  onClick
}) {
  const content = icon ? /* @__PURE__ */ React95.createElement("span", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, icon, children) : children;
  if (type === "text" || type === "textDefault") {
    return /* @__PURE__ */ React95.createElement(
      FTextBtn_default2,
      {
        type: type === "text" ? "primary" : "default",
        className,
        style,
        disabled,
        onClick
      },
      content
    );
  }
  return /* @__PURE__ */ React95.createElement(
    FRectBtn_default2,
    {
      type: rectTypeMap[type],
      size,
      className,
      style,
      disabled,
      onClick
    },
    content
  );
}
var FButton_default = FButton;

// src/FText/FContentText/index.tsx
import * as React96 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/FContentText/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/FContentText/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__text__zD3e4 {\n  text-align: left;\n}\n.index__normal__ZtWsg {\n  color: #222;\n  line-height: 20px;\n  font-size: 14px;\n  font-weight: 400;\n}\n.index__highlight__gDP-v {\n  color: #222;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 600;\n}\n.index__negative__zs8-f {\n  font-size: 14px;\n  line-height: 20px;\n  color: #999;\n}\n.index__additional1__4tLX5 {\n  line-height: 19px;\n  color: #999;\n  font-size: 13px;\n}\n.index__additional2__D-8-7 {\n  line-height: 18px;\n  color: #999;\n  font-size: 12px;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FContentText_default = { "text": "index__text__zD3e4", "normal": "index__normal__ZtWsg", "highlight": "index__highlight__gDP-v", "negative": "index__negative__zs8-f", "additional1": "index__additional1__4tLX5", "additional2": "index__additional2__D-8-7" };

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/shared.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/shared.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".shared__singleRow__nxBnK {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var shared_default = { "singleRow": "shared__singleRow__nxBnK" };

// src/FText/FContentText/index.tsx
var FContentText = React96.forwardRef(({
  className,
  style,
  children,
  text,
  type = "normal",
  singleRow = false
}, ref) => {
  const singleRowClassName = singleRow ? shared_default.singleRow : "";
  return /* @__PURE__ */ React96.createElement(
    "div",
    {
      ref,
      style,
      className: [singleRowClassName, FContentText_default[type], FContentText_default.text, className].join(" ")
    },
    children || text
  );
});
var FContentText_default2 = FContentText;

// src/FText/FTitleText/index.tsx
import * as React97 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/FTitleText/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/FTitleText/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__text__7v2x6 {\n  font-weight: 400;\n  margin: 0;\n  text-align: left;\n}\n.index__h1__OrKs7 {\n  font-size: 24px;\n  line-height: 30px;\n  font-weight: 600;\n}\n.index__h2__EjgC9 {\n  font-size: 20px;\n  line-height: 26px;\n}\n.index__h3__Lbgj9 {\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n}\n.index__h4__o9K9C {\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: 600;\n  color: #7A869A;\n}\n.index__popup__Ea23w {\n  font-size: 18px;\n  line-height: 24px;\n}\n.index__table__d-VAD {\n  font-size: 13px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #7A869A;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FTitleText_default = { "text": "index__text__7v2x6", "h1": "index__h1__OrKs7", "h2": "index__h2__EjgC9", "h3": "index__h3__Lbgj9", "h4": "index__h4__o9K9C", "popup": "index__popup__Ea23w", "table": "index__table__d-VAD" };

// src/FText/FTitleText/index.tsx
function FTitleText({ children, style, className, text, type = "h1", singleRow = false }) {
  const singleRowClassName = singleRow ? shared_default.singleRow : "";
  const finalClassName = [singleRowClassName, FTitleText_default[type], FTitleText_default.text, className].join(" ");
  switch (type) {
    case "h1":
      return /* @__PURE__ */ React97.createElement("h1", { className: finalClassName, style }, children || text);
    case "h2":
      return /* @__PURE__ */ React97.createElement("h2", { className: finalClassName, style }, children || text);
    case "h3":
      return /* @__PURE__ */ React97.createElement("h3", { className: finalClassName, style }, children || text);
    case "h4":
      return /* @__PURE__ */ React97.createElement("h4", { className: finalClassName, style }, children || text);
    case "popup":
      return /* @__PURE__ */ React97.createElement("h5", { className: finalClassName, style }, children || text);
    default:
      return /* @__PURE__ */ React97.createElement("h6", { className: finalClassName, style }, children || text);
  }
}
var FTitleText_default2 = FTitleText;

// src/FText/FTipText/index.tsx
import * as React98 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/FTipText/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FText/FTipText/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__text__swOEN {\n  color: #666;\n  text-align: left;\n}\n.index__first__tbNJX {\n  font-size: 30px;\n  line-height: 36px;\n}\n.index__second__rzdpQ {\n  font-size: 16px;\n  line-height: 22px;\n}\n.index__third__Y4tGl {\n  font-size: 14px;\n  line-height: 20px;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FTipText_default = { "text": "index__text__swOEN", "first": "index__first__tbNJX", "second": "index__second__rzdpQ", "third": "index__third__Y4tGl" };

// src/FText/FTipText/index.tsx
function FTipText({ type = "first", text, className = "", style, singleRow }) {
  const singleRowClassName = singleRow ? shared_default.singleRow : "";
  return /* @__PURE__ */ React98.createElement(
    "div",
    {
      className: [singleRowClassName, FTipText_default[type], FTipText_default.text, className].join(" "),
      style
    },
    text
  );
}
var FTipText_default2 = FTipText;

// src/FHeaderNavigation/index.tsx
import * as React104 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__FHeaderNavigation__JxGsW {\n  padding: 0 40px;\n  height: 70px;\n  background: white;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.05);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 1280px;\n  position: relative;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 {\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__logoLink__5A1kZ {\n  color: #222;\n  transition: opacity 0.25s;\n  display: flex;\n  align-items: center;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__logoLink__5A1kZ > i {\n  font-size: 24px;\n  line-height: 30px;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__logoLink__5A1kZ > span {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 21px;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__logoLink__5A1kZ:hover {\n  opacity: 0.7;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__alphaTestLabel__fnoGe {\n  background: #2784FF;\n  border-radius: 12px;\n  line-height: 20px;\n  padding: 0 10px;\n  font-size: 10px;\n  font-weight: 600;\n  color: white;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__Menus__YMEZV {\n  display: flex;\n  height: 70px;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__Menus__YMEZV .index__NavLink__ujgdS {\n  font-size: 14px;\n  font-weight: 400;\n  color: #222;\n  line-height: 20px;\n  transition: color 0.25s, font-weight 0.25s;\n  padding: 0 15px;\n  height: 70px;\n  display: flex;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__Menus__YMEZV .index__NavLink__ujgdS > span {\n  display: flex;\n  align-items: center;\n  border-top: 2px solid transparent;\n  border-bottom: 2px solid transparent;\n  height: 100%;\n  width: fit-content;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__Menus__YMEZV .index__NavLink__ujgdS:hover {\n  color: #2784FF;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__Menus__YMEZV .index__NavLink__ujgdS.index__activated__HZU5x {\n  color: #2784FF;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Left__LNCw9 .index__Menus__YMEZV .index__NavLink__ujgdS.index__activated__HZU5x > span {\n  border-bottom-color: #2784FF;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Right__pUITc {\n  height: 70px;\n  display: flex;\n  align-items: center;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Right__pUITc .index__createBtnMenu__bnnyF {\n  display: flex;\n  width: 32px;\n  height: 70px;\n  align-items: center;\n  justify-content: center;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Right__pUITc .index__createBtnMenu__bnnyF > span {\n  display: flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 14px;\n  background-color: #2784FF;\n  border-radius: 50%;\n}\n.index__FHeaderNavigation__JxGsW .index__FHeaderNavigation_Right__pUITc .index__createBtnMenu__bnnyF:hover > span {\n  background-color: #529DFF;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FHeaderNavigation_default = { "FHeaderNavigation": "index__FHeaderNavigation__JxGsW", "FHeaderNavigation_Left": "index__FHeaderNavigation_Left__LNCw9", "logoLink": "index__logoLink__5A1kZ", "alphaTestLabel": "index__alphaTestLabel__fnoGe", "Menus": "index__Menus__YMEZV", "NavLink": "index__NavLink__ujgdS", "activated": "index__activated__HZU5x", "FHeaderNavigation_Right": "index__FHeaderNavigation_Right__pUITc", "createBtnMenu": "index__createBtnMenu__bnnyF" };

// src/FHeaderNavigation/UserInfo/index.tsx
import * as React99 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/UserInfo/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/UserInfo/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__userPanel__l8sBp {\n  width: 240px;\n  background-color: white;\n}\n.index__userPanelHeader__Kk01p {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.index__userPanelHeader__Kk01p > img {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n}\n.index__registerName__Uuh5z {\n  font-size: 12px;\n  color: #999;\n  line-height: 18px;\n}\n.index__userPanelMenu__h8wOO > a {\n  line-height: 60px;\n  padding: 0 20px;\n  display: block;\n  color: #222;\n  transition: none;\n  border-top: 1px solid #f0f0f0;\n}\n.index__userPanelMenu__h8wOO > a:hover {\n  background-color: #2784FF;\n  color: white;\n}\n.index__avatar__59aSN {\n  height: 70px;\n  display: flex;\n  border-radius: 50%;\n  align-items: center;\n}\n.index__avatar__59aSN > img {\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var UserInfo_default = { "userPanel": "index__userPanel__l8sBp", "userPanelHeader": "index__userPanelHeader__Kk01p", "registerName": "index__registerName__Uuh5z", "userPanelMenu": "index__userPanelMenu__h8wOO", "avatar": "index__avatar__59aSN" };

// src/FHeaderNavigation/UserInfo/index.tsx
import { FUtil as FUtil2 } from "@freelog/tools-lib";
import { Space as Space2 } from "antd";
function UserInfo({ data }) {
  if (!data) {
    return /* @__PURE__ */ React99.createElement(Space2, { size: 10 }, /* @__PURE__ */ React99.createElement(
      index_default.FRectBtn,
      {
        type: "default",
        size: "small",
        onClick: () => {
          window.location.href = FUtil2.Format.completeUrlByDomain("user") + FUtil2.LinkTo.login({
            goTo: window.location.href
          });
        }
      },
      "\u767B\u5F55"
    ), /* @__PURE__ */ React99.createElement(
      index_default.FRectBtn,
      {
        type: "primary",
        size: "small",
        onClick: () => {
          window.location.href = FUtil2.Format.completeUrlByDomain("user") + FUtil2.LinkTo.logon({
            goTo: window.location.href
          });
        }
      },
      "\u6CE8\u518C"
    ));
  }
  const { info, menu } = data;
  return /* @__PURE__ */ React99.createElement(index_default.FDropdown, { overlay: /* @__PURE__ */ React99.createElement("div", { className: UserInfo_default.userPanel }, /* @__PURE__ */ React99.createElement("div", { className: UserInfo_default.userPanelHeader }, info.avatar ? /* @__PURE__ */ React99.createElement(
    "div",
    {
      style: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `url(${info.avatar})`,
        width: 60,
        height: 60,
        borderRadius: "50%",
        // Figma：inside border rgba(0,0,0,0.1)
        boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)"
      }
    }
  ) : /* @__PURE__ */ React99.createElement(index_default.FIcons.FUser, { style: { fontSize: 36 } }), /* @__PURE__ */ React99.createElement("div", { style: { height: 10 } }), /* @__PURE__ */ React99.createElement(
    index_default.FContentText,
    {
      type: "highlight",
      text: info.creatorName || info.userName
    }
  ), !!info.creatorName && /* @__PURE__ */ React99.createElement(React99.Fragment, null, /* @__PURE__ */ React99.createElement("div", { style: { height: 6 } }), /* @__PURE__ */ React99.createElement("div", { className: UserInfo_default.registerName }, info.userName))), /* @__PURE__ */ React99.createElement("div", { className: UserInfo_default.userPanelMenu }, menu.map((m) => {
    return /* @__PURE__ */ React99.createElement(
      "a",
      {
        key: m.text,
        onClick: (e) => {
          e.preventDefault();
          m.onClick();
        }
      },
      m.text
    );
  }))) }, /* @__PURE__ */ React99.createElement("a", { className: UserInfo_default.avatar }, info.avatar ? /* @__PURE__ */ React99.createElement(
    "div",
    {
      style: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundImage: `url(${info.avatar})`,
        width: 32,
        height: 32,
        borderRadius: "50%",
        // Figma：inside border rgba(0,0,0,0.1)
        boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)"
      }
    }
  ) : /* @__PURE__ */ React99.createElement(index_default.FIcons.FUser, { style: { fontSize: 18 } })));
}
var UserInfo_default2 = UserInfo;

// src/FHeaderNavigation/EmptyAndCreate/index.tsx
import * as React101 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/EmptyAndCreate/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/EmptyAndCreate/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__emptyDropdown__hJIOA {\n  height: 180px;\n  padding: 0 50px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  background-color: white;\n}\n.index__Link__tc1fT {\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  justify-content: center;\n  height: 32px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n  border: none;\n  color: white;\n  background-color: #2784FF;\n  transition: background-color 0.25s;\n}\n.index__Link__tc1fT:hover {\n  background-color: #529DFF;\n  color: white;\n}\n.index__Link__tc1fT:active {\n  background-color: #2376E5;\n  color: white;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var EmptyAndCreate_default = { "emptyDropdown": "index__emptyDropdown__hJIOA", "Link": "index__Link__tc1fT" };

// src/FHeaderNavigation/AOrLink/index.tsx
import * as React100 from "react";
function AOrLink({ children, href, target, className = "", style = {}, UmiLinkPatch }) {
  const Link = UmiLinkPatch;
  return /* @__PURE__ */ React100.createElement(React100.Fragment, null, href.startsWith("http") || !Link ? /* @__PURE__ */ React100.createElement(
    "a",
    {
      className,
      style,
      href,
      target
    },
    children
  ) : /* @__PURE__ */ React100.createElement(
    Link,
    {
      className,
      style,
      to: href,
      target
    },
    children
  ));
}
var AOrLink_default = AOrLink;

// src/FHeaderNavigation/EmptyAndCreate/index.tsx
function EmptyAndCreate({ tipText, btnText, btnHref, target = "_self", UmiLinkPatch, onSelect }) {
  return /* @__PURE__ */ React101.createElement("div", { className: EmptyAndCreate_default.emptyDropdown }, /* @__PURE__ */ React101.createElement(index_default.FContentText, { text: tipText }), /* @__PURE__ */ React101.createElement("div", { style: { height: 30 } }), /* @__PURE__ */ React101.createElement("div", { onClick: () => {
    onSelect && onSelect();
  } }, /* @__PURE__ */ React101.createElement(
    AOrLink_default,
    {
      className: EmptyAndCreate_default.Link,
      href: btnHref,
      target,
      UmiLinkPatch
    },
    btnText
  )));
}
var EmptyAndCreate_default2 = EmptyAndCreate;

// src/FHeaderNavigation/NavList/index.tsx
import * as React102 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/NavList/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHeaderNavigation/NavList/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__NavList__PZCwi {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.index__NavList__PZCwi .index__NavItem__1WRxh {\n  display: flex;\n  height: 40px;\n  align-items: center;\n  color: #222;\n  transition: none;\n  padding: 0 70px 0 20px;\n}\n.index__NavList__PZCwi .index__NavItem__1WRxh.index__active__Gewg0 {\n  color: #2784FF;\n}\n.index__NavList__PZCwi .index__NavItem__1WRxh:hover {\n  color: white;\n  background-color: #2784FF;\n}\n.index__NavList__PZCwi .index__newButton__BoyJg {\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  color: #222;\n  transition: none;\n  border-top: 1px solid #E4E7EB;\n}\n.index__NavList__PZCwi .index__newButton__BoyJg:hover {\n  color: white;\n  background-color: #2784FF;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var NavList_default = { "NavList": "index__NavList__PZCwi", "NavItem": "index__NavItem__1WRxh", "active": "index__active__Gewg0", "newButton": "index__newButton__BoyJg" };

// src/FHeaderNavigation/NavList/index.tsx
function NavList({ items, createBtn = null, activeID = "", UmiLinkPatch, onSelect }) {
  return /* @__PURE__ */ React102.createElement(
    "div",
    {
      className: NavList_default.NavList
    },
    /* @__PURE__ */ React102.createElement("div", { style: { height: 10 } }),
    items.map((i) => {
      return /* @__PURE__ */ React102.createElement("div", { key: i.id, onClick: () => {
        onSelect && onSelect();
      } }, /* @__PURE__ */ React102.createElement(
        AOrLink_default,
        {
          className: [NavList_default.NavItem, i.id === activeID ? NavList_default.active : ""].join(" "),
          href: i.href,
          UmiLinkPatch
        },
        i.text
      ));
    }),
    /* @__PURE__ */ React102.createElement("div", { style: { height: 10 } }),
    createBtn && /* @__PURE__ */ React102.createElement("div", { onClick: () => {
      onSelect && onSelect();
    } }, /* @__PURE__ */ React102.createElement(
      AOrLink_default,
      {
        className: NavList_default.newButton,
        href: createBtn.href,
        target: createBtn.target,
        UmiLinkPatch
      },
      /* @__PURE__ */ React102.createElement(index_default.FIcons.FPlus, { style: { fontSize: 14 } })
    ))
  );
}
var NavList_default2 = NavList;

// src/FHeaderNavigation/index.tsx
import { FUtil as FUtil3, FI18n as FI18n2 } from "@freelog/tools-lib";

// src/FHotspotTooltip/index.tsx
import * as React103 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHotspotTooltip/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FHotspotTooltip/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__outerRing__djLYU {\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.01);\n  border: 1px solid #B06AB3;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.index__outerRing__djLYU .index__innerCircle__WLixB {\n  width: 10px;\n  height: 10px;\n  background: linear-gradient(135deg, #4568DC 0%, #B06AB3 100%);\n  border-radius: 50%;\n  animation: 1s linear 0s infinite alternate index__breathing__rM3uU;\n}\n@keyframes index__breathing__rM3uU {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.8);\n  }\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FHotspotTooltip_default = { "outerRing": "index__outerRing__djLYU", "innerCircle": "index__innerCircle__WLixB", "breathing": "index__breathing__rM3uU" };

// src/FHotspotTooltip/index.tsx
import { Tooltip } from "antd";
var HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY = "HotspotTooltip";
var defaultContent = {
  "header.gotoConsoleBtn": "show",
  "createResourcePage.createBtn": "hide",
  "createResourceVersionPage.uploadFileBtn": "show",
  "createResourceVersionPage.createBtn": "hide",
  "policyBuilder.resource.policyTemplateBtn": "show",
  "policyBuilder.resource.policyVerifyBtn": "hide",
  "policyBuilder.resource.policyCreateBtn": "show",
  "header.discoverNav": "hide",
  "createNodePage.createBtn": "hide",
  "resourceDetailPage.nodeSelector": "show",
  "resourceDetailPage.checkPolicy": "show",
  "policyBuilder.exhibit.policyTemplateBtn": "show",
  "policyBuilder.exhibit.policyVerifyBtn": "hide",
  "policyBuilder.exhibit.policyCreateBtn": "show",
  "nodeManager.nodeLink": "show",
  "exhibitDetailPage.onlineSwitch": "hide",
  "exhibitDetailPage.createFirstPolicy": "show",
  "resourceVersionEditorPage.noVersionAndCreateVersion": "show"
};
function getHotspotTooltip_LocalStorage_Content(key) {
  const contentString = self.localStorage.getItem(HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY) || "{}";
  const content = JSON.parse(contentString);
  return content[key];
}
function setHotspotTooltip_LocalStorage_Content(key, value) {
  const contentString = self.localStorage.getItem(HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY) || "{}";
  const content = JSON.parse(contentString);
  const newContentString = JSON.stringify({
    ...content,
    [key]: value
  });
  self.localStorage.setItem(HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY, newContentString);
}
var set_visible_funcs = {};
function FHotspotTooltip({ id, children, style = {}, text, onMount, zIndex = 1e4 }) {
  const ref = React103.useRef();
  const [visible, set_visible] = React103.useState((getHotspotTooltip_LocalStorage_Content(id) || defaultContent[id]) === "show");
  React103.useEffect(() => {
    set_visible_funcs[id] = set_visible;
    onMount && onMount();
  }, []);
  if (!visible) {
    return /* @__PURE__ */ React103.createElement(React103.Fragment, null, children);
  }
  return /* @__PURE__ */ React103.createElement(
    "div",
    {
      ref,
      style: { width: "fit-content", height: "fit-content", position: "relative" }
    },
    children,
    /* @__PURE__ */ React103.createElement(
      Tooltip,
      {
        visible: true,
        placement: "bottomRight",
        title: text,
        color: "#FFFFFF linear-gradient(135deg, #4568DC 0%, #B06AB3 100%)",
        overlayInnerStyle: {
          padding: "12px 20px",
          borderRadius: 8
        },
        getPopupContainer: () => ref.current,
        zIndex
      },
      /* @__PURE__ */ React103.createElement("div", { style: {
        ...style,
        width: 40,
        position: "absolute",
        zIndex,
        maxWidth: 240
      } }, /* @__PURE__ */ React103.createElement("div", { className: FHotspotTooltip_default.outerRing }, /* @__PURE__ */ React103.createElement("div", { className: FHotspotTooltip_default.innerCircle })))
    )
  );
}
var FHotspotTooltip_default2 = FHotspotTooltip;
function setHotspotTooltipVisible(id, option) {
  if (option.onlyNullish && getHotspotTooltip_LocalStorage_Content(id) !== void 0) {
    return;
  }
  if (option.effectiveImmediately) {
    const func = set_visible_funcs[id];
    func && func(option.value);
  }
  setHotspotTooltip_LocalStorage_Content(id, option.value ? "show" : "hide");
}

// src/FHeaderNavigation/index.tsx
import { Space as Space3 } from "antd";
function FHeaderNavigation({
  logoBtn,
  showAlphaTest = false,
  showConsoleBabel = false,
  menu = [],
  activeIDs = ["", ""],
  extra,
  showGotoConsole = false,
  createBtnMenu = [],
  userPanel,
  UmiLinkPatch,
  showHotspotTooltip
}) {
  const ref = React104.useRef(null);
  return /* @__PURE__ */ React104.createElement("div", { className: FHeaderNavigation_default.FHeaderNavigation, ref }, /* @__PURE__ */ React104.createElement("div", { className: FHeaderNavigation_default.FHeaderNavigation_Left }, /* @__PURE__ */ React104.createElement(AOrLink_default, { href: logoBtn.href, className: FHeaderNavigation_default.logoLink, UmiLinkPatch }, /* @__PURE__ */ React104.createElement("i", { className: "freelog fl-icon-a-featherlogo5" }), showConsoleBabel && /* @__PURE__ */ React104.createElement(React104.Fragment, null, /* @__PURE__ */ React104.createElement("div", { style: { width: 10 } }), /* @__PURE__ */ React104.createElement("span", null, "\xB7 \u5DE5\u4F5C\u53F0"))), showAlphaTest && /* @__PURE__ */ React104.createElement(React104.Fragment, null, /* @__PURE__ */ React104.createElement("div", { style: { width: 10 } }), /* @__PURE__ */ React104.createElement("label", { className: FHeaderNavigation_default.alphaTestLabel }, "\u5185\u6D4B")), menu && menu.length > 0 && /* @__PURE__ */ React104.createElement(React104.Fragment, null, /* @__PURE__ */ React104.createElement("div", { style: { width: 25 } }), /* @__PURE__ */ React104.createElement("div", { className: FHeaderNavigation_default.Menus }, menu.map((m) => {
    return /* @__PURE__ */ React104.createElement(
      MenuDropdown,
      {
        key: m.id,
        m,
        activeIDs,
        UmiLinkPatch,
        showHotspotTooltip: showHotspotTooltip || false
      }
    );
  })))), /* @__PURE__ */ React104.createElement("div", { className: FHeaderNavigation_default.FHeaderNavigation_Right }, extra, /* @__PURE__ */ React104.createElement("div", { style: { width: 30 } }), /* @__PURE__ */ React104.createElement(Space3, { size: 30 }, showGotoConsole && /* @__PURE__ */ React104.createElement(React104.Fragment, null, showHotspotTooltip ? /* @__PURE__ */ React104.createElement(
    FHotspotTooltip_default2,
    {
      id: "header.gotoConsoleBtn",
      style: { left: "50%", marginLeft: -16, bottom: -42 },
      text: FI18n2.i18nNext.t("hotpots_home_btn_gotoconsole"),
      onMount: () => {
        setHotspotTooltipVisible("header.gotoConsoleBtn", {
          value: false,
          effectiveImmediately: false,
          onlyNullish: false
        });
      }
    },
    /* @__PURE__ */ React104.createElement(
      index_default.FRectBtn,
      {
        size: "small",
        type: "secondary",
        onClick: () => {
          window.open(FUtil3.Format.completeUrlByDomain("console") + FUtil3.LinkTo.dashboard());
        }
      },
      "\u8FDB\u5165\u5DE5\u4F5C\u53F0"
    )
  ) : /* @__PURE__ */ React104.createElement(
    index_default.FRectBtn,
    {
      size: "small",
      type: "secondary",
      onClick: () => {
        window.open(FUtil3.Format.completeUrlByDomain("console") + FUtil3.LinkTo.dashboard());
      }
    },
    "\u8FDB\u5165\u5DE5\u4F5C\u53F0"
  )), createBtnMenu && createBtnMenu.length > 0 && /* @__PURE__ */ React104.createElement(React104.Fragment, null, /* @__PURE__ */ React104.createElement(
    index_default.FDropdown,
    {
      getPopupContainer: () => {
        return ref.current || self.document.body;
      },
      overlay: /* @__PURE__ */ React104.createElement(
        NavList_default2,
        {
          items: createBtnMenu,
          UmiLinkPatch
        }
      )
    },
    /* @__PURE__ */ React104.createElement(
      "a",
      {
        className: FHeaderNavigation_default.createBtnMenu,
        id: "header.createBtn"
      },
      /* @__PURE__ */ React104.createElement("span", null, /* @__PURE__ */ React104.createElement(index_default.FIcons.FPlus, null))
    )
  )), /* @__PURE__ */ React104.createElement(UserInfo_default2, { data: userPanel }))));
}
var FHeaderNavigation_default2 = FHeaderNavigation;
function MenuDropdown({ m, UmiLinkPatch, activeIDs, showHotspotTooltip }) {
  const [visible, set_visible] = React104.useState(false);
  return /* @__PURE__ */ React104.createElement(
    index_default.FDropdown,
    {
      visible,
      onVisibleChange: (v) => {
        set_visible(v);
      },
      key: m.id,
      disabled: m.items.length === 0 && !m.emptyItemsTip,
      overlay: m.items.length === 0 && m.emptyItemsTip ? /* @__PURE__ */ React104.createElement(
        EmptyAndCreate_default2,
        {
          UmiLinkPatch,
          ...m.emptyItemsTip,
          onSelect: () => {
            set_visible(false);
          }
        }
      ) : /* @__PURE__ */ React104.createElement(
        NavList_default2,
        {
          items: m.items,
          createBtn: m.createBtn,
          activeID: activeIDs[1],
          UmiLinkPatch,
          onSelect: () => {
            set_visible(false);
          }
        }
      )
    },
    m.id === "discover" && showHotspotTooltip ? /* @__PURE__ */ React104.createElement(
      FHotspotTooltip_default2,
      {
        id: "header.discoverNav",
        style: { left: "50%", marginLeft: -16, bottom: -20 },
        text: FI18n2.i18nNext.t("hotpots_myresource_nav_explore")
      },
      /* @__PURE__ */ React104.createElement(
        AOrLink_default,
        {
          href: m.href,
          target: m.target,
          className: [FHeaderNavigation_default.NavLink, activeIDs[0] === m.id ? FHeaderNavigation_default.activated : ""].join(" "),
          UmiLinkPatch
        },
        /* @__PURE__ */ React104.createElement("span", null, m.text)
      )
    ) : /* @__PURE__ */ React104.createElement(
      AOrLink_default,
      {
        href: m.href,
        target: m.target,
        className: [FHeaderNavigation_default.NavLink, activeIDs[0] === m.id ? FHeaderNavigation_default.activated : ""].join(" "),
        UmiLinkPatch
      },
      /* @__PURE__ */ React104.createElement("span", null, m.text)
    )
  );
}

// src/FCodeFormatter/index.tsx
import * as React105 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FCodeFormatter/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FCodeFormatter/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__code__xQN3A {\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: #222222;\n  line-height: 24px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow: hidden;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FCodeFormatter_default = { "code": "index__code__xQN3A" };

// src/FCodeFormatter/index.tsx
function FCodeFormatter({ code }) {
  return /* @__PURE__ */ React105.createElement("pre", { className: FCodeFormatter_default.code }, code);
}
var FCodeFormatter_default2 = FCodeFormatter;

// src/FContractStatusBadge/index.tsx
import * as React106 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FContractStatusBadge/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FContractStatusBadge/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__style__eJDf1 {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n  color: #FFFFFF;\n  padding: 0 10px;\n  border-radius: 10px;\n  display: inline-block;\n}\n.index__active__uwvrC {\n  background-color: #44C28C;\n}\n.index__testActive__9Qd9v {\n  background-color: #44C28C;\n}\n.index__inactive__mu92I {\n  background-color: #E9A923;\n}\n.index__terminal__L-0QT {\n  background-color: #999;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FContractStatusBadge_default = { "style": "index__style__eJDf1", "active": "index__active__uwvrC", "testActive": "index__testActive__9Qd9v", "inactive": "index__inactive__mu92I", "terminal": "index__terminal__L-0QT" };

// src/FContractStatusBadge/index.tsx
var statusTextObj = {
  active: "\u5DF2\u6388\u6743",
  testActive: "\u6D4B\u8BD5\u6388\u6743",
  inactive: "\u672A\u6388\u6743",
  terminal: "\u5DF2\u7EC8\u6B62"
};
function FContractStatusBadge({ status }) {
  return /* @__PURE__ */ React106.createElement("label", { className: [FContractStatusBadge_default.style, FContractStatusBadge_default[status]].join(" ") }, statusTextObj[status]);
}
var FContractStatusBadge_default2 = FContractStatusBadge;

// src/FCopyToClipboard/index.tsx
import * as React107 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FCopyToClipboard/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FCopyToClipboard/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__color__U5lv2 {\n  font-size: 12px;\n  color: #222;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FCopyToClipboard_default = { "color": "index__color__U5lv2" };

// src/FCopyToClipboard/index.tsx
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Tooltip as Tooltip2 } from "antd";
var CopyToClipboard_Copy = CopyToClipboard;
function FCopyToClipboard({ text, title, success, iconStyle, children }) {
  const [tip, setTip] = React107.useState(title);
  return /* @__PURE__ */ React107.createElement(
    Tooltip2,
    {
      trigger: "hover",
      title: /* @__PURE__ */ React107.createElement("span", { className: FCopyToClipboard_default.color }, tip),
      color: "#fff",
      placement: "bottomLeft",
      mouseLeaveDelay: 0,
      mouseEnterDelay: 0
    },
    /* @__PURE__ */ React107.createElement("span", { onMouseOut: () => {
      setTimeout(() => setTip(title), 100);
    } }, /* @__PURE__ */ React107.createElement(
      CopyToClipboard_Copy,
      {
        text,
        onCopy: (_text, result) => {
          if (result) {
            setTip(success || "\u590D\u5236\u6210\u529F");
          }
        }
      },
      children || /* @__PURE__ */ React107.createElement(FTextBtn_default2, null, /* @__PURE__ */ React107.createElement(FIcons_default.FCopy, { style: iconStyle }))
    ))
  );
}
var FCopyToClipboard_default2 = FCopyToClipboard;

// src/FInput/FMultiLine/index.tsx
import * as React108 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FMultiLine/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FMultiLine/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__introduction__PSw-T {\n  display: flex;\n  position: relative;\n}\n.index__introduction__PSw-T > span {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n}\n.index__introduction__PSw-T .index__TextArea__vqJRF {\n  width: 100%;\n  display: block;\n}\n.index__introduction__PSw-T .ant-input:focus {\n  border-color: #2784FF;\n}\n.index__introduction__PSw-T .ant-input-focused {\n  border-color: #2784FF;\n}\n.index__introduction__PSw-T .index__FInputWordCount__yAYQ7 {\n  color: #C4C4C4;\n}\n.index__introduction__PSw-T .index__beyond__YVyA1 {\n  color: #EE4040;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FMultiLine_default = { "introduction": "index__introduction__PSw-T", "TextArea": "index__TextArea__vqJRF", "FInputWordCount": "index__FInputWordCount__yAYQ7", "beyond": "index__beyond__YVyA1" };

// src/FInput/FMultiLine/index.tsx
import { Input } from "antd";
function FMultiLineInput({
  value,
  placeholder = "",
  className = "",
  // hasError = false,
  style = {},
  lengthLimit = 600,
  onChange,
  onBlur,
  onPressEnter,
  autoSize = {}
}, ref) {
  return /* @__PURE__ */ React108.createElement("div", { className: FMultiLine_default.introduction }, /* @__PURE__ */ React108.createElement(
    Input.TextArea,
    {
      ref,
      value,
      placeholder,
      className: [FMultiLine_default.TextArea, className].join(" "),
      style,
      onChange,
      onBlur,
      onPressEnter,
      autoSize: {
        minRows: 4,
        maxRows: 20,
        ...autoSize
      }
    }
  ), lengthLimit > 0 && /* @__PURE__ */ React108.createElement(
    "span",
    {
      className: [FMultiLine_default.FInputWordCount, value.length > lengthLimit ? FMultiLine_default.beyond : ""].join(" ")
    },
    lengthLimit - value.length
  ));
}
var FMultiLine_default2 = React108.forwardRef(FMultiLineInput);

// src/FInput/FSearch/index.tsx
import * as React109 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FSearch/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FSearch/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__Input__dACpU {\n  border-width: 1px;\n  border-style: solid;\n  width: 160px;\n}\n.index__Input__dACpU:hover {\n  border-color: #CBCBCB;\n}\n.index__Input__dACpU:focus {\n  border-color: #2784FF !important;\n}\n.index__Input__dACpU.index__InputError__67wOf,\n.index__Input__dACpU.index__InputError__67wOf:hover,\n.index__Input__dACpU.index__InputError__67wOf:active,\n.index__Input__dACpU.index__InputError__67wOf:focus {\n  border-color: #EE4040;\n}\n.index__dark__BxLyi {\n  border-color: rgba(0, 0, 0, 0.03);\n  background-color: rgba(0, 0, 0, 0.03);\n  border-radius: 22px;\n}\n.index__dark__BxLyi input {\n  background-color: transparent;\n}\n.index__darkPrefix__cblUl {\n  color: #8E8E93;\n  font-size: 14px;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FSearch_default = { "Input": "index__Input__dACpU", "InputError": "index__InputError__67wOf", "dark": "index__dark__BxLyi", "darkPrefix": "index__darkPrefix__cblUl" };

// src/FInput/FSearch/index.tsx
import { Input as Input2 } from "antd";
function FSearchInput({
  value,
  placeholder = "",
  className = "",
  size = "middle",
  style = {},
  lengthLimit = 100,
  onChange,
  onPressEnter
}, ref) {
  return /* @__PURE__ */ React109.createElement(
    Input2,
    {
      ref,
      value,
      placeholder,
      className: [className, FSearch_default.Input, FSearch_default.dark].join(" "),
      style: {
        height: size === "middle" ? 38 : 32,
        ...style
      },
      prefix: /* @__PURE__ */ React109.createElement("i", { className: ["freelog", "fl-icon-content", FSearch_default.darkPrefix].join(" ") }),
      onChange: (e) => {
        const str = e.target.value.substring(0, lengthLimit);
        if (str !== value) {
          onChange && onChange(str);
        }
      },
      onPressEnter,
      allowClear: true
    }
  );
}
var FSearch_default2 = React109.forwardRef(FSearchInput);

// src/FInput/FPassword/index.tsx
import * as React110 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FPassword/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FPassword/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__styles__mBNe0 {\n  border-width: 1px;\n  border-style: solid;\n  border-color: #E4E7EB;\n  background-color: white;\n  height: 38px;\n}\n.index__styles__mBNe0:hover {\n  border-color: #CBCBCB !important;\n}\n.index__styles__mBNe0:focus {\n  border-color: #2784FF !important;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FPassword_default = { "styles": "index__styles__mBNe0" };

// src/FInput/FPassword/index.tsx
import { Input as Input3 } from "antd";
function FPasswordInput({ className, ...props }) {
  return /* @__PURE__ */ React110.createElement(
    Input3.Password,
    {
      ...props,
      className: [className, FPassword_default.styles].join(" ")
    }
  );
}
var FPassword_default2 = FPasswordInput;

// src/FInput/FSingleLine/index.tsx
import * as React111 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FSingleLine/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FSingleLine/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__disabledInput__1qUkR {\n  border-width: 1px;\n  border-style: solid;\n  width: 160px;\n  border-color: #E4E7EB;\n}\n.index__Input__-3oYi {\n  border-width: 1px;\n  border-style: solid;\n  width: 160px;\n  background-color: white;\n  border-color: #E4E7EB;\n}\n.index__Input__-3oYi:hover {\n  border-color: #CBCBCB;\n}\n.index__Input__-3oYi:focus {\n  border-color: #2784FF !important;\n}\n.index__Input__-3oYi.index__InputError__B9M9s,\n.index__Input__-3oYi.index__InputError__B9M9s:hover,\n.index__Input__-3oYi.index__InputError__B9M9s:active,\n.index__Input__-3oYi.index__InputError__B9M9s:focus {\n  border-color: #EE4040;\n}\n.index__FInputWordCount__hnrwx {\n  color: #C4C4C4;\n}\n.index__FInputWordCount__hnrwx.index__beyond__FasD5 {\n  color: #EE4040;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FSingleLine_default = { "disabledInput": "index__disabledInput__1qUkR", "Input": "index__Input__-3oYi", "InputError": "index__InputError__B9M9s", "FInputWordCount": "index__FInputWordCount__hnrwx", "beyond": "index__beyond__FasD5" };

// src/FInput/FSingleLine/index.tsx
import { Input as Input4 } from "antd";
function FSingleLineInput({
  autoFocus = false,
  disabled = false,
  value,
  placeholder = "",
  className = "",
  hasError = false,
  size = "middle",
  style = {},
  lengthLimit = 100,
  onChange,
  onPressEnter,
  onKeyUp,
  onBlur
}, ref) {
  return /* @__PURE__ */ React111.createElement(
    Input4,
    {
      autoFocus,
      disabled,
      value,
      ref,
      placeholder,
      className: [className, disabled ? FSingleLine_default.disabledInput : FSingleLine_default.Input, hasError ? FSingleLine_default.InputError : ""].join(" "),
      style: {
        height: size === "middle" ? 38 : 32,
        ...style
      },
      onPressEnter,
      onKeyUp,
      onChange,
      suffix: lengthLimit > 0 ? /* @__PURE__ */ React111.createElement(
        "span",
        {
          className: [FSingleLine_default.FInputWordCount, lengthLimit - value.length < 0 ? FSingleLine_default.beyond : ""].join(" ")
        },
        lengthLimit - value.length
      ) : void 0,
      onBlur
    }
  );
}
var FSingleLine_default2 = React111.forwardRef(FSingleLineInput);

// src/FInput/FPaymentPassword/index.tsx
import * as React112 from "react";

// less-modules:/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FPaymentPassword/index.less
(function() {
  if (typeof document !== "undefined") {
    var id = "/Users/lk/github/freelogfe-web-repos/packages/@freelog/components-lib/src/FInput/FPaymentPassword/index.less";
    if (!document.querySelector('style[data-file="' + id + '"]')) {
      var s = document.createElement("style");
      s.setAttribute("data-file", id);
      s.textContent = ".index__styles__NyFtw {\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  position: relative;\n}\n.index__styles__NyFtw > input {\n  position: absolute;\n  border: 0;\n  clip: rect(0px, 0px, 0px, 0px);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  bottom: -1px;\n  left: -1px;\n}\n.index__styles__NyFtw .index__InputBox__LvYFW {\n  border-radius: 4px;\n  border: 1px solid #D4D4D4;\n  width: 42px;\n  height: 38px;\n  background-color: white;\n  color: #222;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  line-height: 1;\n}\n.index__styles__NyFtw .index__InputBox__LvYFW.index__InputBoxActivated__uaNAF {\n  border-color: #2784FF;\n  color: #2784FF;\n}\n";
      document.head.appendChild(s);
    }
  }
})();
var FPaymentPassword_default = { "styles": "index__styles__NyFtw", "InputBox": "index__InputBox__LvYFW", "InputBoxActivated": "index__InputBoxActivated__uaNAF" };

// src/FInput/FPaymentPassword/index.tsx
import { Space as Space4 } from "antd";
var FPaymentPasswordInput = React112.forwardRef(({
  value,
  autoFocus = false,
  onChange,
  onBlur
}, ref) => {
  const inputEl = React112.useRef(null);
  const [isFocus, setIsFocus] = React112.useState(false);
  return /* @__PURE__ */ React112.createElement("div", { className: FPaymentPassword_default.styles }, /* @__PURE__ */ React112.createElement(
    "input",
    {
      autoComplete: "off",
      autoFocus,
      type: "text",
      minLength: 6,
      maxLength: 6,
      ref: ref || inputEl,
      value,
      onChange: (e) => {
        onChange && onChange(e.target.value.replace(/[^\d]/g, ""));
      },
      onFocus: () => {
        setIsFocus(true);
      },
      onBlur: () => {
        setIsFocus(false);
        onBlur && onBlur();
      }
    }
  ), /* @__PURE__ */ React112.createElement(Space4, { size: 10, onClick: () => {
    (ref || inputEl).current.focus();
  } }, Array(6).fill(null).map((_, inx) => {
    return /* @__PURE__ */ React112.createElement(
      "div",
      {
        className: [FPaymentPassword_default.InputBox, isFocus && (value.length === inx || inx === 5 && value.length >= 6) ? FPaymentPassword_default.InputBoxActivated : ""].join(" ")
      },
      isFocus && value.length === inx && /* @__PURE__ */ React112.createElement("span", null, "|"),
      value.length > inx && /* @__PURE__ */ React112.createElement("span", null, "\u25CF")
    );
  })));
});
var FPaymentPassword_default2 = FPaymentPasswordInput;

// src/FInput/index.tsx
var Input5 = {
  FMultiLine: FMultiLine_default2,
  FSearch: FSearch_default2,
  FPassword: FPassword_default2,
  FSingleLine: FSingleLine_default2,
  FPaymentPassword: FPaymentPassword_default2
};
var FInput_default = Input5;

// src/index.tsx
var FComponentsLib = {
  FIcons: FIcons_default,
  F_Contract_And_Policy_Labels: F_Contract_And_Policy_Labels_default2,
  FPageFooter: FPageFooter_default2,
  FDropdown: FDropdown_default2,
  FTextBtn: FTextBtn_default2,
  FRectBtn: FRectBtn_default2,
  FCircleBtn: FCircleBtn_default2,
  FButton: FButton_default,
  FContentText: FContentText_default2,
  FTipText: FTipText_default2,
  FTitleText: FTitleText_default2,
  FHeaderNavigation: FHeaderNavigation_default2,
  FCodeFormatter: FCodeFormatter_default2,
  FContractStatusBadge: FContractStatusBadge_default2,
  // FPaymentPasswordInput,
  FCopyToClipboard: FCopyToClipboard_default2,
  FHotspotTooltip: FHotspotTooltip_default2,
  fSetHotspotTooltipVisible: setHotspotTooltipVisible,
  FInput: FInput_default
};
var index_default = FComponentsLib;
export {
  index_default as default
};
//# sourceMappingURL=index.mjs.map